<template>
  <div class>
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>
        <v-icon class="icon">fa-pencil-alt</v-icon>Edit Partner
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small @click="closePanel" :color="this.$gf.headerColor()">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-form>
            <v-text-field
              :error-messages="messages.first_name"
              v-model="partner.first_name"
              label="First Name"
              type="text"
              filled
            ></v-text-field>
            <v-text-field
              :error-messages="messages.last_name"
              v-model="partner.last_name"
              label="Last Name"
              type="text"
              filled
            ></v-text-field>
            <v-text-field
              :error-messages="messages.email"
              v-model="partner.email"
              label="Email"
              type="text"
              filled
            ></v-text-field>
            <v-text-field
              :error-messages="messages.phone"
              v-model="partner.phone"
              label="Phone"
              type="text"
              filled
            ></v-text-field>
            <v-text-field
              v-model="partner.address1"
              :error-messages="messages.address"
              label="Address Line 1"
              type="text"
              filled
            ></v-text-field>
            <v-text-field
              v-model="partner.address2"
              :error-messages="messages.address2"
              label="Address Line 2"
              type="text"
              filled
            ></v-text-field>
            <v-text-field
              v-model="partner.city"
              :error-messages="messages.city"
              label="City"
              type="text"
              filled
            ></v-text-field>
            <v-text-field
              v-model="partner.postcode"
              :error-messages="messages.postcode"
              label="Postcode"
              type="text"
              filled
            ></v-text-field>
            <v-text-field v-if="$globalConfig.APP_NAME == 'senso'"
              v-model="partner.referral_url"
              :error-messages="messages.referral_url"
              label="Referral Url"
              type="text"
              filled
            ></v-text-field>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer  height="68">
      <v-flex text-right>
        <v-btn color="primary" class="mr-1" @click="closePanel">Cancel</v-btn>
        <v-btn color="primary" @click="updatePartner">Save</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import partnerAPI from '@/api/partner.js';

export default {
  name: 'Editpartner',
  props: {
    id: {
      type: String,
      default: null,
    },
    params: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      messages: {},
      partnerLevelList: [
        {
          name: 'Tier 1',
          id: 1,
        },
        {
          name: 'Tier 2',
          id: 2,
        },
      ],
      partner: {},
      partnerCompanyList: [],
      isLevelTier2: false,
      successMessage: 'Partner Successfully Updated.',
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',
    };
  },
  mounted() {
    this.getPartner(this.id);
  },
  methods: {
    closePanel() {
      this.$emit('closePanel', {});
    },
    getPartner(id) {
      partnerAPI.getPartnerByID(id).then((response) => {
        this.partner = response.data.data;
      });
    },
    updatePartner() {
      partnerAPI
        .updatePartner(this.id, this.partner)
        .then(() => {
          this.$store.dispatch('profile');
          this.closePanel();
          EventBus.$emit('PARTNER_UPDATED', this.params);
          this.$snotify.success(this.successMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
  },
};
</script>
